// Google Analytics
const GA4_MEASUREMENT_IDS = {
  ja: 'G-PFF15PY5VV', // 日本語版のGA4計測ID
  en: 'G-CGVDBEBZR0', // 英語版のGA4計測ID
} as const;

const BUILD_LANG = (document.documentElement.lang as 'ja' | 'en') || 'ja';
export const GA4_MEASUREMENT_ID = GA4_MEASUREMENT_IDS[BUILD_LANG];

export const initGA4 = () => {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer!.push(arguments);
  };

  window.gtag('js', new Date());
  window.gtag('config', GA4_MEASUREMENT_ID, {
    send_page_view: false,
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
  document.head.appendChild(script);
};
